import { render, staticRenderFns } from "./Pemutakhiran.vue?vue&type=template&id=4748cdf2&"
import script from "./Pemutakhiran.vue?vue&type=script&lang=js&"
export * from "./Pemutakhiran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports